var _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNowtrackerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79753e-06 32C4.89568e-06 8 8.00001 2.73372e-06 32 4.83187e-06C56 6.93001e-06 64 8.00001 64 32C64 56 56 64 32 64C8 64 6.99382e-07 56 2.79753e-06 32Z",
    fill: "#6CB0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79753e-06 32C4.89568e-06 8 8.00001 2.73372e-06 32 4.83187e-06C56 6.93001e-06 64 8.00001 64 32C64 56 56 64 32 64C8 64 6.99382e-07 56 2.79753e-06 32Z",
    fill: "#255DC8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.6914,
    y: 23.6309,
    width: 6.89231,
    height: 17.7231,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5547,
    y: 31.5078,
    width: 6.89231,
    height: 9.84615,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.416,
    y: 28.5537,
    width: 6.89231,
    height: 12.8,
    rx: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowtrackerIcon);
export default __webpack_public_path__ + "static/media/nowtracker-icon.fc36f128a39892cda6ca9bd336d33d22.svg";
export { ForwardRef as ReactComponent };